export enum PartyType {
  CLIENT = <any>'CLIENT',
  PROPERTY = <any>'PROPERTY',
  AGENCY = <any>'AGENCY'
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/models/party-type.ts